/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ROUTES, useConfigurationSelector } from "@bms/common";
import { useCallback } from "react";
import { useHistory } from "react-router";

type RegisterRouteState = Record<string, unknown>;

export const useRegisterNavigation = () => {
  const history = useHistory();
  const { System } = useConfigurationSelector() || {};
  const registrationUrl = System?.RegistrationUrl;
  const isExternalRegistration = !!registrationUrl;

  const goToRegister = useCallback(
    (state?: RegisterRouteState) => {
      if (registrationUrl) {
        window.location.href = registrationUrl;
        return;
      }

      history.push({
        pathname: ROUTES.REGISTER,
        state: {
          ...state,
          from: window.location?.pathname,
        },
      });
    },
    [history, registrationUrl],
  );

  return {
    goToRegister,
    isExternalRegistration,
    registrationUrl,
    registerPath: ROUTES.REGISTER,
  };
};
